<template>
  <canvas class="watermark" ref="watermark" :style="`opacity: ${opacity}`"></canvas>
</template >

<script>
/**
 * Customizable watermark for screen and print.
 * @version 1.0.0
 */
export default {
  name: "ReportDraftWatermark",
  props: {
    /**
     * The text for the watermark
     */
    text: {
      type: String,
      default: "Draft"
    },
    /**
     * Adds extra space around text
     */
    padding: {
      type: Number,
      default: 75
    },
    /**
     * The color for the watermark text.
     * @see See [Wikipedia](https://en.wikipedia.org/wiki/Web_colors#HTML_color_names)
     * @see See [MDN](https://developer.mozilla.org/en-US/docs/Web/CSS/color_value) for a list of color names
     */
    color: {
      type: String,
      default: 'black'
    },
    /**
     * Font size for the watermark text
     */
    fontSize: {
      type: Number,
      default: 24
    },
    /**
     * Font family for the watermark text
     */
    fontFamily: {
      type: String,
      default: "Arial, sans-serif"
    },
    /**
     * The amount of transparency for the watermark text
     */
    opacity: {
      type: Number,
      default: .07
    }
  },
  computed: {
    /**
     * Gets the height of the parent component's root element
     * @returns {Number}
     */
    parentHeight() {
      return this.$parent.$el.offsetHeight
    }
  },
  methods: {
    /**
     * Create the watermark image
     * @returns {HTMLCanvasElement}
     */
    createWatermark() {
      const watermark = document.createElement('canvas')
      const ctx = watermark.getContext("2d");
      const watermark_text = this.text.toUpperCase();

      ctx.font = `${this.fontSize}px ${this.fontFamily}`; // this line is NOT redundant

      const text_measurements = ctx.measureText(watermark_text);
      const posXY = text_measurements.width / 2;

      watermark.width = text_measurements.width + this.padding;
      watermark.height = text_measurements.width + this.padding;

      ctx.font = `${this.fontSize}px ${this.fontFamily}`; // this line is NOT redundant
      ctx.fillStyle = this.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = "bottom";

      ctx.save();
      ctx.translate(posXY, posXY);
      ctx.rotate(-45 * Math.PI / 180);
      ctx.fillText(watermark_text, 0, this.fontSize / 2);
      ctx.restore();

      return watermark
    },
    /**
     * Render the watermark to the page
     */
    renderWatermark() {
      const watermark = this.createWatermark();
      const canvas_tiles = this.$refs.watermark;
      const ctx2 = canvas_tiles.getContext('2d');

      canvas_tiles.width = window.innerWidth;
      canvas_tiles.height = this.parentHeight;

      ctx2.fillStyle = ctx2.createPattern(watermark, 'repeat');
      ctx2.fillRect(0, 0, canvas_tiles.width, canvas_tiles.height);
    }
  },
  mounted() {
    this.renderWatermark()
  }
}
</script>

<style scoped>
  .watermark {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    pointer-events: none;
    background: transparent;
  }
</style>